module.exports = __webpack_public_path__ + "static/media/pacific.09f0f512.png";